// material-ui
import {
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  Stack,
  Typography,
} from "@mui/material";

// project import
import Avatar from "components/@extended/Avatar";
import { FormattedMessage,useIntl } from "react-intl";
import { PopupTransition } from "components/@extended/Transitions";

//import { deleteCustomer } from 'api/customer';
import { openSnackbar } from "api/snackbar";

// assets
import { DeleteFilled } from "@ant-design/icons";

// types
import { SnackbarProps } from "types/snackbar";
import { useAppDispatch } from "hooks";
import { deleteCountry } from "store/actions/main/countries";
import { useState } from "react";

interface Props {
  id: number;
  title: string;
  open?: boolean;
  handleClose?: () => void;
  fetchData?: any;
}

// ==============================|| CUSTOMER - DELETE ||============================== //

export default function AlertCountryDelete({
  id,
  title,
  open,
  fetchData,
  handleClose,
}: Props) {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false)
  const handleDelete = () => {
    setIsLoading(true)
    dispatch(deleteCountry({ countryId: id })).then((action) => {
      fetchData();
      if (action.type === "country/deleteCountry/fulfilled") {
        setIsLoading(false)
        openSnackbar({
          open: true,
          message: "Country deleted successfully",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "alert",
          alert: {
            color: "success",
          },
        } as SnackbarProps);
        handleClose();
      }
      else{
        
        setIsLoading(false);
       
        openSnackbar({
          open: true,
          message: action.payload,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "alert",
          close:false,
          alert: {
            color: "error",
          },
        } as SnackbarProps);
      }
    });
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      keepMounted
      TransitionComponent={PopupTransition}
      maxWidth="xs"
      aria-labelledby="column-delete-title"
      aria-describedby="column-delete-description"
    >
      <DialogContent sx={{ mt: 2, my: 1 }}>
        <Stack alignItems="center" spacing={3.5}>
          <Avatar
            color="error"
            sx={{ width: 72, height: 72, fontSize: "1.75rem" }}
          >
            <DeleteFilled />
          </Avatar>
          <Stack spacing={2}>
            <Typography variant="h4" align="center">
              <FormattedMessage id="Are you sure you want to delete" />
            </Typography>
            <Typography align="center">
              <FormattedMessage id="By deleting" />
              <Typography variant="subtitle1" component="span">
                {" "}
                "{title}"{" "}
              </Typography>
              <FormattedMessage id="all data assigned to that category will also be deleted" />
            </Typography>
          </Stack>

          <Stack direction="row" spacing={2} sx={{ width: 1 }}>
            <Button
              fullWidth
              onClick={handleClose}
              color="secondary"
              variant="outlined"
            >
              <FormattedMessage id="Cancel" />
            </Button>
            <Button
              fullWidth
              color="error"
              variant="contained"
              onClick={handleDelete}
              autoFocus
            >
              {isLoading? <CircularProgress size="1rem" color="inherit"/> :  <FormattedMessage id="Delete" />}
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
